export const ECP_WORKFLOW_IS_CONFIRMATION_MODAL = "ECP_WORKFLOW_IS_CONFIRMATION_MODAL"
export const ECP_WORKFLOW_IS_GLOSSARY_MODAL = "ECP_WORKFLOW_IS_GLOSSARY_MODAL"
export const CLEAN_ECP_WORKFLOW_CONTEXT = "CLEAN_ECP_WORKFLOW_CONTEXT"